import { AppColors } from '@cmbg-traky-web/design-system';
import { CSSProperties } from 'react';

type TrackingOrdersStyles = {
  ordersTable: CSSProperties;
  ordersTableTablet: CSSProperties;
  tableContainerTablet: CSSProperties;
  ordersTableMobile: CSSProperties;
  tableContainerMobile: CSSProperties;
  sub: CSSProperties;
  footerBar: CSSProperties;
  footerBarTablet: CSSProperties;
  footerBarMobile: CSSProperties;
  columTitle: CSSProperties;
  customerName: CSSProperties;
  invoiceCell: CSSProperties;
  invoiceCellLabel: CSSProperties;
  invoiceCellMeta: CSSProperties;
  associationBadge: CSSProperties;
  associationText: CSSProperties;
  associationDocId: CSSProperties;
};

const styles: TrackingOrdersStyles = {
  ordersTable: {
    marginTop: 32
  },
  ordersTableTablet: {
    marginTop: 24,
    width: '100%',
    minWidth: '1200px'
  },
  tableContainerTablet: {
    width: '100%',
    overflowX: 'auto'
  },
  ordersTableMobile: {
    marginTop: 16,
    width: '100%',
    minWidth: '900px'
  },
  tableContainerMobile: {
    width: '100%',
    overflowX: 'auto'
  },
  sub: {
    color: AppColors.VA.NEUTRALS._60_
  },
  footerBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 16
  },
  footerBarTablet: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 12
  },
  footerBarMobile: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 12
  },
  columTitle: {
    fontWeight: '600'
  },
  customerName: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    wordBreak: 'break-word',
    lineHeight: '1.3em',
    maxHeight: '2.6em',
    whiteSpace: 'normal',
    hyphens: 'auto'
  },
  invoiceCell: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    minWidth: 0
  },
  invoiceCellLabel: {
    display: 'block',
    fontWeight: 600,
    fontFamily: 'inherit',
    letterSpacing: 0.2,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0
  },
  invoiceCellMeta: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0
  },
  associationBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 8px',
    marginTop: 2,
    background: AppColors.VA.NEUTRALS._10_,
    borderRadius: 6,
    border: `1px solid ${AppColors.VA.NEUTRALS._20_}`,
    width: 'fit-content',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  associationText: {
    color: AppColors.VA.NEUTRALS._60_,
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '14px',
    whiteSpace: 'nowrap',
    flexShrink: 0
  },
  associationDocId: {
    color: AppColors.VA.PRIMARY._50_,
    fontSize: 11,
    fontWeight: 700,
    lineHeight: '14px',
    letterSpacing: 0.2,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0
  }
};

export const border = `1px solid ${AppColors.VA.NEUTRALS._20_}`;
export default styles;
